// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connect-form[data-v-14342632]{width:100%;box-shadow:none}.form-title[data-v-14342632]{font-weight:500;font-size:32px;line-height:40px;color:#000}.form-text[data-v-14342632]{font-weight:400;font-size:16px;line-height:24px;color:rgba(7,6,0,.7)}.form-text--gray[data-v-14342632]{color:rgba(7,6,0,.5)}.label-kved[data-v-14342632]{color:#00bbf9}.v-chip[data-v-14342632]{background-color:rgba(0,187,249,.2)!important}", ""]);
// Exports
module.exports = exports;
